import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import s from './WorkTracker.module.scss';

// One short line of feedback ("Saved.") that goes away by itself.
export default function Toast({ toast, onDone }) {
  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(onDone, toast.tone === 'error' ? 4000 : 1800);
    return () => clearTimeout(t);
  }, [toast, onDone]);
  if (!toast) return null;
  return <div className={s.toast} data-tone={toast.tone || 'ok'} role="status">{toast.text}</div>;
}

Toast.propTypes = {
  toast: PropTypes.shape({ text: PropTypes.string.isRequired, tone: PropTypes.string }),
  onDone: PropTypes.func.isRequired,
};
Toast.defaultProps = { toast: null };
